<div class="course-reviews">
  <div class="section-title">
    <h4 class="h4 pt-2" *ngIf="!reviewsTitle">{{translationScope+'.reviews' | transloco}}</h4>
    <h4 class="h4 pt-2" *ngIf="reviewsTitle"> {{ reviewsTitle }}</h4>
  </div>

  <div *ngIf="reviews?.length && (reviews?.length > 0)" class="reviews">
    <app-review-card *ngFor="let review of reviews;let isLast=last"
      [name]="review.user.name"
      [rating]="review.value"
      [imageUrl]="review.user.image"
      [experienceName]="course.title"
      [comment]="review?.comment"
      [bottom_border]="!isLast"
      >
    </app-review-card>
  </div>

  <button *ngIf="reviews.length < reviewTotalCount" (click)="loadReviews()" class="btn btn-link">
    {{translationScope+'.read_more_reviews' | transloco}}
    <img class="plus-icon " alt="icon">
  </button>
</div>
